"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutletService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class OutletService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetch(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.by_sub_business_name !== null &&
                    payload.by_sub_business_name !== undefined
                    ? `${this.baseUrl}business/outlet/list?by_sub_business_name=${payload.by_sub_business_name}&page=${payload.pageNumber}&limit=${payload.limit}`
                    : `${this.baseUrl}business/outlet/list?page=${payload.pageNumber}&limit=${payload.limit}`;
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i].key = i;
                }
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Error in fetching outlets');
            }
        });
    }
    create(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/outlet/create`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post((url = url), payload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data.data.id;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    update(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/outlet/edit`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.patch((url = url), payload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    fetchOutletsForOwner(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/outlet/owner/list?page=${payload.pageNumber}&limit=${payload.limit}`;
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Error in fetching outlets');
            }
        });
    }
    fetchOutletsForFranchise(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/outlet/franchise/list?page=${payload.pageNumber}&limit=${payload.limit}`;
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error('Error in fetching outlets');
            }
        });
    }
    fetchSubBusiness() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/outlet/sub_business/name/list`;
                const response = yield axios_1.default.get((url = url), {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error('Error in fetching sub business');
            }
        });
    }
}
exports.OutletService = OutletService;
